module.exports = __webpack_public_path__ + "static/media/CCU_Arg-15.81201a8c.png";